export const BOOKMARKED_JOB_IDS_STORAGE_KEY = 'bookmarkedJobIds';
export const BOOKMARKS_UPDATED_EVENT = 'bookmarks:updated';

const getStoredBookmarkIds = (): string[] => {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const storedBookmarkIds = window.localStorage.getItem(
      BOOKMARKED_JOB_IDS_STORAGE_KEY,
    );
    const parsedBookmarkIds = storedBookmarkIds
      ? JSON.parse(storedBookmarkIds)
      : [];
    return Array.isArray(parsedBookmarkIds) ? parsedBookmarkIds : [];
  } catch (_err) {
    return [];
  }
};

export const getBookmarkedJobIds = (): string[] => getStoredBookmarkIds();

export const isBookmarked = (jobId: string): boolean => {
  if (!jobId) return false;
  return getStoredBookmarkIds().includes(jobId);
};

/**
 * Adds or removes a job ID from the bookmarks in localStorage.
 * Dispatches a 'bookmarks:updated' custom event so other components
 * (both React and vanilla DOM) can react to the change.
 */
export const toggleBookmark = (jobId: string): void => {
  if (!jobId || typeof window === 'undefined') {
    return;
  }

  const bookmarkIds = getStoredBookmarkIds();
  const nextBookmarkIds = bookmarkIds.includes(jobId)
    ? bookmarkIds.filter((id) => id !== jobId)
    : [...bookmarkIds, jobId];

  window.localStorage.setItem(
    BOOKMARKED_JOB_IDS_STORAGE_KEY,
    JSON.stringify(nextBookmarkIds),
  );

  window.dispatchEvent(
    new CustomEvent(BOOKMARKS_UPDATED_EVENT, {
      detail: { bookmarks: nextBookmarkIds },
    }),
  );
};
